/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RecurringIntervalEnum {
  MONTH = "month",
  YEAR = "year",
}
